var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.baseClass,attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"size":90,"width":7,"color":"primary","indeterminate":true}}),_c('span',{staticStyle:{"font-size":"18px","font-weight":"bold","margin-bottom":"14px","color":"#143693"}},[_vm._v(" "+_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }